import HTTP from "../../http";

const PRODUCTS_ENDPOINT = "/products";
const STORES_ENDPOINT = "/stores";

export async function getProductsForStore(store) {
  return await HTTP.get(PRODUCTS_ENDPOINT + `?store=${store}`);
}

export async function getStoreByName(storeName) {
  return await HTTP.get(STORES_ENDPOINT + `/${storeName}`);
}
